(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningCategoryDetailController', WarningCategoryDetailController);

    WarningCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'WarningCategory'];

    function WarningCategoryDetailController($scope, $rootScope, $stateParams, entity, WarningCategory) {
        var vm = this;
        vm.warningCategory = entity;
        
        var unsubscribe = $rootScope.$on('jotApp:warningCategoryUpdate', function(event, result) {
            vm.warningCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
